var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4575 2.45532C21.3413 2.35498 21.1999 2.28825 21.0486 2.26231C20.8973 2.23637 20.7417 2.25222 20.5987 2.30814L1.59937 9.74345C1.3301 9.84815 1.10214 10.0375 0.949797 10.283C0.797454 10.5284 0.728977 10.8168 0.754676 11.1045C0.780374 11.3923 0.898857 11.6639 1.09229 11.8785C1.28572 12.0931 1.54362 12.2391 1.82718 12.2944L6.74999 13.2609V18.75C6.74902 19.049 6.83787 19.3414 7.00503 19.5893C7.17219 19.8372 7.40995 20.0291 7.68749 20.1403C7.96461 20.2535 8.26936 20.2806 8.56213 20.2183C8.85489 20.1559 9.12211 20.0069 9.32906 19.7906L11.7028 17.3288L15.4687 20.625C15.7404 20.866 16.0909 20.9994 16.4541 21C16.6132 20.9999 16.7714 20.9749 16.9228 20.9259C17.1703 20.8474 17.3928 20.7055 17.5683 20.5142C17.7438 20.3229 17.8662 20.0889 17.9231 19.8356L21.7284 3.28126C21.7625 3.13196 21.7552 2.97622 21.7075 2.83072C21.6598 2.68522 21.5734 2.55545 21.4575 2.45532ZM16.4559 19.5L8.70468 12.7031L19.8609 4.7072L16.4559 19.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram-logo.9e1c84d395b5b9f61a6f896872b86e7d.svg";
export { ForwardRef as ReactComponent };